import { Patient } from "@/api/dtos";
import PatientQueryTable from "@/components/tables/PatientQueryTable";
import { Box, Paper, styled } from "@mui/material";
import { InstitutionContext, PageLayout, PatientBreadcrumbs, PatientContext, PatientInformation, PatientStateContext } from "@ngt/opms";
import { Permission, usePermissionsByIds } from "@ngt/opms-bctapi";
import { DateTime } from "luxon";
import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";


const StyledContainer = styled(Paper)(({theme}) => ({
    padding: theme.spacing(3)
}));

const StyledTableContainer = styled(Box)(({theme}) => ({
    padding: theme.spacing(4, 0, 0, 0)
}));

interface IPatientQueriesPage {
    
}

const PatientQueriesPage: React.FunctionComponent<IPatientQueriesPage> = () => {
    const navigate = useNavigate();

    const { data: institution } = useContext(InstitutionContext);
    const { data: patient } = useContext(PatientContext);
    const { data: patientState } = useContext(PatientStateContext);
    const {
        permissions: [
            canOpmsAdmin,
            canOpmsDataManage, 
            canViewPatient
        ],
        loading: permissionsLoading
    } = usePermissionsByIds(
        [
            Permission.OpmsAdminister,
            Permission.OpmsDataManage,
            Permission.OpmsPatientView,
        ], 
        undefined, 
        undefined, 
        institution?.id
    );
    
    const canAdministerOpms = useMemo(() => {
        return canOpmsAdmin || canOpmsDataManage;
    }, [canOpmsAdmin, canOpmsDataManage]);

    React.useEffect(() => {
        if (!permissionsLoading) {
            if (!canViewPatient) {
                navigate(`/registration`, {replace: true});
            }
        }
    }, [canViewPatient, permissionsLoading, navigate]);
    
    const patientCaption = useMemo(() => !canAdministerOpms ? (patient as Patient)?.initials ?? 'Unknown' : ' ', [patient, canAdministerOpms]);
    const patientStateCaption = useMemo(() => DateTime.fromISO((patient as Patient)?.patientStateChangeDate ?? DateTime.local().toISO({ includeOffset: false })).toFormat('dd-MMM-yyyy'), [patient]);
    const patientStateName = useMemo(() => {
        return patientState?.name;
    }, [patient?.patientStateId, patientState]);
    
    return (
        <PageLayout
            breadcrumbs={<PatientBreadcrumbs />}
            heading='Participant Queries'
        >
            <StyledContainer>
                <PatientInformation
                    patientCaption={patientCaption}
                    patientStateText={patientStateName}
                    patientStateCaption={patientStateCaption}
                />
                <StyledTableContainer>
                    <Box
                        sx={{
                            mt: 2
                        }}
                    >
                        <PatientQueryTable 
                            title='Queries'
                            disableColumnMenu={false}
                        />
                    </Box>
                </StyledTableContainer>
            </StyledContainer>
        </PageLayout>
    );
}

export default PatientQueriesPage;